import ContentLoader from "react-content-loader";

import { ContentLoadProps } from "types";

const ContentLoad = ({ radius = "0px" }: ContentLoadProps) => {
  const getThemeBluishGreyColor = () =>
    localStorage.getItem("theme") === "light" ? "#f6f7f9" : "#4f5568"; // "#6c757d"

  const getThemeBoneGreyColor = () =>
    localStorage.getItem("theme") === "light" ? "#a9afbf" : "#4f556810"; // "#c5c1c1"

  return (
    <ContentLoader
      speed={1.5}
      width={"100%"}
      height={"100%"}
      backgroundColor={getThemeBoneGreyColor()}
      foregroundColor={getThemeBluishGreyColor()}
    >
      <rect width="100%" rx={radius} height="100%" />
    </ContentLoader>
  );
};

export default ContentLoad;
